import { render, staticRenderFns } from "./page-load-indicator.component.vue?vue&type=template&id=5a7f9ed6&"
import script from "./page-load-indicator.component.vue?vue&type=script&lang=ts&"
export * from "./page-load-indicator.component.vue?vue&type=script&lang=ts&"
import style0 from "./page-load-indicator.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports